import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity PublicPlace
 */

@Entity()
export class PublicPlace extends Partner {
  public static override _class = 'PublicPlace';

  public override get type() {
    return KooperationsPartner.OEFFENTLICHE_STELLE;
  }
}
